import { render, staticRenderFns } from "./packagegreetinglist.vue?vue&type=template&id=272a3640"
import script from "./packagegreetinglist.vue?vue&type=script&lang=js"
export * from "./packagegreetinglist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports